export const COMPANY_DETAIL = 'company_detail'
export const COMPANY_DETAIL_BARE = 'company_detail_bare'
export const COMPANY_LANDING = 'company_landing'
export const COMPANY_LP = 'company_lp'
export const COMPANY_SEARCH = 'company_search'
export const COMPANY_SEARCH_WITH_DETAIL = 'company_search_with_detail'
export const JOB_DETAIL = 'job_detail'
export const JOB_THEME_BARE = 'job_theme_bare'
export const JOB_DETAIL_RESULTS_ONLY = 'job_detail_results_only'
export const JOB_LANDING_WITH_SEO = 'job_landing_with_seo'
export const JOB_LANDING = 'job_landing'
export const JOB_PREVIEW = 'job_preview'
export const JOB_PREVIEW_RESULTS_ONLY = 'job_preview_results_only'
export const JOB_SEARCH = 'job_search'
export const JOB_SEARCH_WITH_DETAIL = 'job_search_with_detail'
export const JOB_THEME_DETACHED = 'job_theme_detached'
export const JOB_THEME_FULL = 'job_theme_full'
export const JOB_THEME_NEUTRAL = 'job_theme_neutral'
export const JOB_THEME_REFERENCE = 'job_theme_reference'
export const LANDING_PAGE_CATALOG = 'job_lp_catalog'
export const COMBINATION_LANDING_PAGE_CATALOG = 'job_combination_lp_catalog'
export const YF_HOME = 'yf_home'
export const RJA_HOME = 'rja_home'
export const JOB_LP = 'job_lp'
export const JOBS_GENERIC_LP = 'jobs_generic_lp'
export const YF_ERROR = 'yf_error'
export const YF_JOBMAIL_UNSUBSCRIBE = 'yf_jobmail_unsubscribe'
export const JOBMAIL_ACTIVATE_ERROR = 'jobmail_activate_error'

export const JOB_THEMES = [
  JOB_THEME_BARE,
  JOB_THEME_DETACHED,
  JOB_THEME_FULL,
  JOB_THEME_NEUTRAL,
  JOB_THEME_REFERENCE
]

export const PAGE_TYPES = [
  YF_HOME,
  RJA_HOME,
  JOB_SEARCH,
  JOB_SEARCH_WITH_DETAIL,
  JOB_DETAIL,
  JOB_DETAIL_RESULTS_ONLY,
  JOB_LANDING_WITH_SEO,
  JOB_LANDING,
  JOBS_GENERIC_LP,
  JOB_PREVIEW,
  JOB_PREVIEW_RESULTS_ONLY,
  JOB_THEME_BARE,
  JOB_THEME_DETACHED,
  JOB_THEME_FULL,
  JOB_THEME_NEUTRAL,
  JOB_THEME_REFERENCE,
  COMPANY_SEARCH,
  COMPANY_SEARCH_WITH_DETAIL,
  COMPANY_DETAIL,
  COMPANY_DETAIL_BARE,
  COMPANY_LANDING,
  COMPANY_LP,
  LANDING_PAGE_CATALOG,
  COMBINATION_LANDING_PAGE_CATALOG,
  JOB_LP,
  YF_ERROR,
  YF_JOBMAIL_UNSUBSCRIBE,
  JOBMAIL_ACTIVATE_ERROR
]
